module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search"},"es":{"search":"Búsqueda"},"sw":{"search":"Tafuta"}}')
  delete Component.options._Ctor
}
